import React from 'react';
import { Icon, Divider } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const UserDefinedLinkRestrictionInfo = ({ datasetCondition }) => {
  const intl = useIntl();
  return (
    <>
      <a target="_blank" rel="noopener noreferrer" href={datasetCondition.context.link}>
        {datasetCondition.context.link_display_name
          || intl.formatMessage({ id: 'dataset.condition.restriction.link.fallback' })}
        &nbsp;
        <Icon name="external" />
      </a>
      {datasetCondition.context.text && <Divider inverted />}
    </>
  );
};

export default UserDefinedLinkRestrictionInfo;
